// BUG-11-CHG-01: stays on raw useAccount. Auth-probe — calls /user/wallet/{address} to check "is THIS connected wallet a known user?". MUST stay on actual connected wallet to keep auth state-machine consistent during impersonation. Probing target's wallet would loop the auth bootstrap.
import { useAccount } from "wagmi";
import { $api } from "@/lib/api-client";

export default function useCheckLogin() {
  const { address } = useAccount();

  return $api.useQuery(
    "get",
    "/user/wallet/{wallet_address}",
    {
      params: {
        path: { wallet_address: address || "" },
      },
    },
    {
      enabled: !!address,
    },
  );
}
